import { ActionContext, ActionTree } from "vuex";
import { RootState } from "@/store/types";
import { ACTION_TYPES, MUTATION_TYPES } from "@/lib/const";
import providers from "@/lib/providers";
import { LoginData, setLoginData, removeLoginData } from "@/lib/authHelper";

const authData = async (context: ActionContext<RootState, RootState>, loginDataResponse: LoginData) => {
  const { authorities, user } = loginDataResponse;
  setLoginData({ authorities, user });
  context.commit("loggedInUser/setLoggedInUser", { user });
  context.commit(`loggedInUser/${MUTATION_TYPES.STORE_DATA}`, { getMyAuthorities: { authorities } });
  await context.dispatch(`settings/${ACTION_TYPES.GET_DATA}`);
  await context.dispatch(`paymentSystems/${ACTION_TYPES.GET_DATA}`);
};

export const actions: ActionTree<RootState, RootState> = {
  async login(context, payload: { email: string; password: string }) {
    await authData(context, await providers.LoginProvider.login(payload));
  },
  async setLogin(context, { user }: LoginData) {
    const loginData = await providers.UserProvider.getMyAuthorities();
    await authData(context, { authorities: loginData.authorities, user: { ...user, role: loginData.role } });
  },
  logout(context) {
    removeLoginData();
    providers.LoginProvider.logout();
    context.dispatch("loggedInUser/logout");
    context.commit("setClientDetails", {
      email: "",
      id: "",
      name: "",
      subscriptionPlan: "ENTERPRISE",
    });
  },
};
